/**
 * Footer row on a LaneBlockCard summarising a patient's progress on a task.
 * Renders one of the `Props` modes: window / ofTotal / streakEnded.
 */

import { Box, useToken } from '@chakra-ui/react';
import { Award, AlertTriangle } from 'lucide-react';
import {
  HStack,
  Text,
} from '@ayble-health/dashboard-components';

type Props =
  | { mode: 'window'; count: number; windowLabel?: string }
  | { mode: 'ofTotal'; count: number; total: number; countNoun?: string }
  | { mode: 'streakEnded'; days: number };

export const EngagementAddon = (props: Props) => {
  const isStreakEnded = props.mode === 'streakEnded';
  const [seafoam, fuschia] = useToken('colors', ['seafoam', 'fuschia']);

  const rowText =
    props.mode === 'streakEnded'
      ? `Streak ended ${props.days} days ago`
      : props.mode === 'ofTotal'
      ? `${props.count} of ${props.total} ${props.countNoun ?? ''}`
          .replace(/\s+/g, ' ')
          .trim() + ' completed'
      : `${props.count} times ${props.windowLabel ?? 'over the last 30 days'}`;

  return (
    <Box w="100%" borderTopWidth="1px" borderTopColor="cloud.200" pt={2} px={2.5} pb={2.5}>
      <HStack align="center" gap={2} w="100%">
        {isStreakEnded ? (
          <AlertTriangle size={14} strokeWidth={2} color={fuschia} />
        ) : (
          <Award size={14} strokeWidth={2} color={seafoam} />
        )}

        <Text
          flex={1}
          minW={0}
          truncate
          color="seafoam"
          fontSize="xs"
          fontWeight="normal"
          lineHeight={1}
          letterSpacing="0.01em"
        >
          {rowText}
        </Text>
      </HStack>
    </Box>
  );
};
